import { SMART_TYPE } from "libs/constant/smartForm";

export const transformDocumentRequired = (documentRequired = []) => {
  const bySeqDoc = (a, b) => parseInt(a.seqDoc) - parseInt(b.seqDoc);
  const bySeqTypeDoc = (a, b) =>
    parseInt(a.seqTypedoc) - parseInt(b.seqTypedoc);
  const flatterTopic = (p, c) => [...p, ...c.topic];

  return documentRequired
    .reduce((prev, cur) => {
      const matchByseqTypedoc = (v) => v.seqTypedoc === cur.seqTypedoc;
      const notMatchByseqTypedoc = (v) => v.seqTypedoc !== cur.seqTypedoc;

      if (prev.some(matchByseqTypedoc)) {
        const listByseqTypedoc = prev
          .filter(matchByseqTypedoc)
          .reduce(flatterTopic, []);

        const otherList = prev.filter(notMatchByseqTypedoc);

        return [
          ...otherList,
          {
            seqTypedoc: cur.seqTypedoc,
            title: cur.typeDocumentName,
            topic: [
              ...listByseqTypedoc,
              {
                title: cur.documentName,
                seqDoc: cur.seqDoc,
                documentID: cur.documentID,
                typedocID: cur.typedocID,
                copy: cur.copy,
                blank: cur.blank,
                c1Y: cur.c1Y,
                c2Y: cur.c2Y,
                c6M: cur.c6M,
                company: cur.company,
                government: cur.government,
                isRequired: cur.isRequired,
                configDocumentRequiredID: cur.configDocumentRequiredID,
              },
            ].sort(bySeqDoc),
          },
        ];
      }

      return [
        ...prev,
        {
          seqTypedoc: cur.seqTypedoc,
          title: cur.typeDocumentName,
          topic: [
            {
              title: cur.documentName,
              seqDoc: cur.seqDoc,
              documentID: cur.documentID,
              typedocID: cur.typedocID,
              copy: cur.copy,
              blank: cur.blank,
              c1Y: cur.c1Y,
              c2Y: cur.c2Y,
              c6M: cur.c6M,
              company: cur.company,
              government: cur.government,
              isRequired: cur.isRequired,
              configDocumentRequiredID: cur.configDocumentRequiredID,
            },
          ],
        },
      ];
    }, [])
    .sort(bySeqTypeDoc);
};

export const countPrevTopic = (docIndex, documents = []) =>
  documents.reduce((p, c, i) => {
    if (i === docIndex || i > docIndex) return p;
    return p + c.topic.length;
  }, 0);

export const transformDocumentTopic = (documents = []) => {
  return documents
    .map((v, docIndex) => ({
      ...v,
      topic: v.topic.map((t, index) => ({
        ...t,
        docIndex: countPrevTopic(docIndex, documents) + index + 1,
      })),
    }))
    .reduce((p, c) => [...p, ...c.topic], []);
};

export const getMinRequired = (status) => {
  if (status === true) return 1;
  return 0;
};

export const getFieldRequired = (fieldName, conditionType) => {
  switch (fieldName) {
    case SMART_TYPE.SMART_I:
      return "copy";
    case "Chamber of Commerce":
      return "copy";
    case SMART_TYPE.SMART_E:
    case SMART_TYPE.SMART_O:
      return "blank";
    case SMART_TYPE.SMART_S: {
      return (
        {
          "1YA": "c1Y",
          "1YB": "c1Y",
          "2Y": "c2Y",
          "6M": "c6M",
          "6MA": "c6M",
          "6MB": "c6M",
          // "1Year": "c1Y",
          // "2Year": "c2Y",
          // "6MonthA": "c6M",
          // "6MonthB": "c6M",
        }[conditionType] || ""
      );
    }
    case SMART_TYPE.SMART_T: {
      const isGovernment = !(
        conditionType === "Start up" || conditionType === "Company"
      );
      return isGovernment ? "government" : "company";
    }
    default:
      return;
  }
};
